import React from 'react';
import "./skills.css";
import Frontend from './Frontend';
import Backend from './Backend';
import DevOps from './DevOps';

const Skills = () => {
  return (
    <section className="skills section" id="skills">
        <h2 className="section__title">Habilidades</h2>
        <span className="section__subtitle">Habilidades Técnicas</span>
        <div className="skills__container container grid">
            <Backend /> 
            <DevOps />
            <Frontend />
        </div>
    </section>
  );
}

export default Skills;